module.exports = __webpack_public_path__ + "img/green_103.550fe2a8.png";